declare let window: any;
/**
 * @todo 防止瀏覽器快取
 */
const PreventHistoryCache = (): void => {
    if (window.performance && window.performance.getEntriesByType('navigation')[0].type === 'back_forward') {
        window.location.reload();
    }
};

/**
 * @todo 非連續字元 檢查
 * @param str
 * @returns
 */
const IsSequence = (str: string) => {
    if (!Object.prototype.hasOwnProperty.call(str, 'length')) return false;
    if (str.length < 3) return false;
    for (let i = 0; i < str.length; ++i) {
        if (str.charCodeAt(i) === str.charCodeAt(i + 1) - 1 && str.charCodeAt(i) === str.charCodeAt(i + 2) - 2) {
            return true;
        }
    }
    return false;
};

/**
 * 3個以上同樣字元 檢查
 * @param str
 * @returns
 */
const IsRepeatThreeTimes = (str: string) => {
    if (!Object.prototype.hasOwnProperty.call(str, 'length')) return false;
    if (str.length < 3) return false;
    for (let i = 0; i < str.length; ++i) {
        if (str[i] === str[i + 1] && str[i] === str[i + 2]) {
            return true;
        }
    }
    return false;
};

/**
 * @todo 檢查身分證格式
 * @param ssn
 * @returns
 */
const CheckSSN = (ssn: string) => {
    if (ssn.search(/^[A-Z](1|2)\d{8}$/i) == -1) return false;
    const tab = 'ABCDEFGHJKLMNPQRSTUVXYWZIO';
    const A1 = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3];
    const A2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5];
    const Mx = [9, 8, 7, 6, 5, 4, 3, 2, 1, 1];

    let i = tab.indexOf(ssn.charAt(0));
    if (i == -1) return false;
    let sum = (A1[i] ?? 0) + (A2[i] ?? 0) * 9;

    for (i = 1; i < 10; i++) {
        const v = parseInt(ssn.charAt(i));
        if (isNaN(v)) return false;
        sum = sum + v * (Mx[i] ?? 0);
    }
    if (sum % 10 != 0) return false;
    return true;
};

/**
 * @todo 只取得中文
 * @param str
 * @returns
 */
const GetChineseStr = (str: string) => {
    if (!Object.prototype.hasOwnProperty.call(str, 'length')) return '';
    const pattern = new RegExp('[\u4E00-\u9FA5]+');
    const phonetic = new RegExp('[\u3100-\u312F]+'); // 注音
    const enPattern = new RegExp('[a-zA-Z]');

    let ans = '';
    const allowCharCode = [32]; // space
    // MODIFIER LETTER APOSTROPHE(,),UP ARROWHEAD(^),LINE BELOW(_), END OF MEDIUM,
    // LATIN SMALL LETTER I WITH STROKE
    // LATIN SMALL LETTER U BAR
    // COLON (:)
    // FULLWIDTH COLON(:)
    const allowCharacter = ['\u02BC', '\u2303', '\u1E5F', '\u0019', '\u0268', '\u0289', '\u003A', '\uFF1A'];

    for (let i = 0; i < str.length; ++i) {
        if (ans.length >= 10) continue;
        const character = str.substring(i, 1);
        const charCode = str.charCodeAt(i);
        if (pattern.test(character)) {
            ans += character;
        } else if (phonetic.test(character)) {
            ans += character;
        } else if (enPattern.test(character)) {
            ans += character;
        } else if (allowCharCode.includes(charCode)) {
            ans += character;
        } else if (allowCharacter.includes(character)) {
            ans += character;
        }
    }
    ans = ans.replace(/\s/, ' ');
    return ans;
};

/**
 * 過濾字串並只取得英文
 * @param str
 * @returns
 */
const GetEngStr = (str: string) => {
    if (!Object.prototype.hasOwnProperty.call(str, 'length')) return '';
    str = str.toLocaleUpperCase();
    let ans = '';
    const allow = [188, 44, 45, 12288, 32];
    for (let i = 0; i < str.length; i++) {
        if (ans.length > 25) continue;
        const val = str.charCodeAt(i);
        // 65280 - 65374	Latin
        if (val > 65248 && val < 65375) {
            ans += String.fromCharCode(val - 65248);
        } else if (allow.includes(val)) {
            ans += str.substring(i, 1);
        } else if (val >= 65 && val <= 90) {
            ans += str.substring(i, 1);
        }
    }
    ans = ans.replace(/\s/, ' ');
    return ans;
};

/**
 * @todo 全形英文與全形標點符號 轉半形
 * @param {any} str
 */
const full2half = (str: string) => {
    const len = str.length;
    const res = [];
    for (let i = 0; i < len; i++) {
        const c = str.charCodeAt(i);
        if (c >= 65280 && c < 65375) {
            res.push(String.fromCharCode(c - 65248));
        } else {
            res.push(str[i]);
        }
    }
    return res.join('');
};

/**
 * @todo 移除所有空白換行
 * @param str
 * @returns
 */
const TrimAllWhitespaces = (str: any) => {
    if (typeof str === 'string') {
        return str.replace(/\s/, '');
    }
    return str;
};

/**
 * @todo 計算年紀
 * @param birth_year
 * @param birth_month
 * @param birth_day
 * @returns
 */
const CalcuateAge = (birth_year: number, birth_month: number, birth_day: number) => {
    const today_date = new Date();
    const today_year = today_date.getFullYear();
    const today_month = today_date.getMonth();
    const today_day = today_date.getDate();
    let age = today_year - birth_year;

    if (today_month < birth_month - 1) {
        age--;
    }
    if (birth_month - 1 == today_month && today_day < birth_day) {
        age--;
    }
    return age;
};

const TWPhoneFormatCheck = (phoneValue: string | undefined | null, fieldName: string) => {
    let errorMsg = '';
    if (!phoneValue) {
        errorMsg = `請輸入${fieldName}\n`;
    } else if (!/^\d+$/.test(phoneValue)) {
        errorMsg = `${fieldName}應為純數字\n`;
    } else if (/^09\d+$/.test(phoneValue)) {
        if (!/^09\d{8}$/.test(phoneValue)) {
            errorMsg = `${fieldName}號碼長度有誤，09開頭必須為10碼\n`;
        }
    } else if (/^02\d+$/.test(phoneValue)) {
        if (!/^02\d{8}$/.test(phoneValue)) {
            errorMsg = `${fieldName}號碼長度有誤，02開頭必須為10碼\n`;
        }
    } else if (/^04\d+$/.test(phoneValue)) {
        if (!/^04\d{7,8}$/.test(phoneValue)) {
            errorMsg = `${fieldName}號碼長度有誤，04開頭必須為9或10碼\n`;
        }
    } else if (/^070(\d+)?$/.test(phoneValue)) {
        if (!/^070\d{8}$/.test(phoneValue)) {
            errorMsg = `${fieldName}號碼長度有誤，070開頭必須為11碼\n`;
        }
    } else if (/^0[3,5,6,7,8]\d+$/.test(phoneValue)) {
        if (!/^0[3,5,6,7,8]\d{7}$/.test(phoneValue)) {
            errorMsg = `${fieldName}號碼長度有誤，03、05、06、07、08開頭必須為9碼\n`;
        }
    } else {
        errorMsg = `${fieldName}格式有誤\n`;
    }
    return errorMsg;
};

/**
 * @todo 檢驗 手機號碼格式
 * @param mobilephone
 * @returns
 */
const MobilephoneFormatCheck = (mobilephone: string): string => {
    let error_msg = '';
    if (!/^09\d{8}$/.test(mobilephone)) {
        error_msg = `手機號碼格式有誤，09開頭必須為10碼純數字\n`;
    }
    return error_msg;
};

/**
 * @todo 取代特殊符號
 * @param value
 * @returns
 */
const ReplaceSpecialChar = (value: string | undefined | null) => {
    if (!value) return '';
    const str = value.replace(new RegExp('\u3000', 'gm'), ' ');
    const regex = /[<>~`!#$%^*=<>?|\\;'"]/g;
    return str.replace(regex, '');
};

/**
 * @todo 一般輸入框長度檢查
 * @param value
 * @param minLen
 * @param maxLen
 * @returns
 */
const GeneralAllowInput = (value: string | undefined | null, minLen: number, maxLen: number): boolean => {
    if (typeof value !== 'string' || !value) return false;
    const res2 = value.length >= minLen && value.length <= maxLen;
    return res2;
};

/**
 * @todo 一般輸入框長度檢查
 * @param value
 * @param maxLen
 * @returns
 */
const ReplaceNumerInput = (value: string | undefined | null, maxLen: number): string => {
    if (typeof value !== 'string' || !value) return '';
    const res = value.replace(/[^0-9]/g, '').slice(0, maxLen);
    return res;
};
/**
 * @todo 個位數字補0
 * @param value
 * @returns
 */
const PaddingText = (value: string, padString: string, length: number): string => {
    while (value.length < length) {
        value = padString + value;
    }
    return value;
};

const ConsoleLog = (value: any): void => {
    if (import.meta.env.DEV) {
        console.log(value);
    }
};

const FileToBase64 = (file: Blob): Promise<any> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
            resolve(e.target?.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsDataURL(file);
    });
};

const ObjectToBase64 = (data: any) => {
    const txEncoder = new TextEncoder().encode(JSON.stringify(data));
    const binString = Array.from(txEncoder, (byte: any) => String.fromCodePoint(byte)).join('');
    return btoa(binString);
};

const Base64ToImage = (base64String: string): Promise<HTMLImageElement> => {
    return new Promise((resolve) => {
        const img = window.document.createElement('img');
        img.onload = () => {
            resolve(img);
        };
        img.src = base64String;
    });
};

/**
 * @todo viewData 設定參數
 * @param source
 * @param index
 * @param defaultValue
 * @returns
 */
const SetValue = <T>(source: any, index: string, defaultValue: any): T => {
    let value = defaultValue;
    if (typeof source[index] !== 'undefined') {
        value = source[index];
    }
    if (typeof value === 'string') {
        value = ReplaceSpecialChar(TrimAllWhitespaces(value));
    }
    return value;
};

const GetLeftTimeText = (timerLeft: number | undefined) => {
    const min = timerLeft !== undefined ? Math.floor(timerLeft / 1000 / 60) : 0; // 剩餘分
    const minStr = min.toString().length <= 1 ? `0${min}` : min.toString();

    const sec = timerLeft !== undefined ? Math.floor((timerLeft / 1000) % 60) : 0; // 剩餘秒
    const secStr = sec.toString().length <= 1 ? `0${sec}` : sec.toString();
    return `${minStr}:${secStr}`;
};

const ToHtmlEntities = (text: string) => {
    return text.replace(/./gm, function (s) {
        // return "&#" + s.charCodeAt(0) + ";";
        return s.match(/[a-z0-9\s]+/i) ? s : '&#' + s.charCodeAt(0) + ';';
    });
};

/**
 * @todo 編碼 HTML 中的特殊字元，防止 XSS 攻擊。這個函數會將一些常見的 HTML 字元（如 <, >, " 等）轉換為 HTML 實體
 * @param input
 * @returns
 */
const HtmlspecialChars = (input: unknown): string => {
    // 檢查輸入是否為字串，若不是則回傳空字串
    if (typeof input !== 'string') return String(input);

    const map: { [key: string]: string } = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;' // 單引號
    };

    return input.replace(/[&<>"']/g, (char) => map[char] || char);
};

/**
 * @todo 嘗試將字串轉換為整數，如果失敗則返回 null
 * @param str
 * @returns
 */
const TryParseInt = (str: string | undefined | null): number | null => {
    if (typeof str !== 'string') return null;
    const parsed = parseInt(str, 10);
    return isNaN(parsed) ? null : parsed;
};

/**
 * @todo 嘗試將字串轉換為浮點數，如果失敗則返回 0
 * @param str
 * @returns
 */
const ParseFloat = (str: string | undefined | null): number => {
    if (typeof str !== 'string') return 0;
    const parsed = parseFloat(str);
    return isNaN(parsed) ? 0 : parsed;
};

/**
 * 節流函式，用於限制函式的執行頻率。
 * 確保函式在指定的毫秒數內最多執行一次。
 * @param func 要節流的函式
 * @param limit 節流時間（毫秒）
 * @returns 節流後的函式
 */
const Throttle = (func: Function, limit: number) => {
    let inThrottle: boolean;
    return function (this: any, ...args: any[]) {
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
        }
    };
};

const IsFileNameValid = (name: string, maxLength: number = 255): boolean => {
    return new TextEncoder().encode(name).length <= maxLength;
};

export {
    PreventHistoryCache,
    IsSequence,
    IsRepeatThreeTimes,
    CheckSSN,
    GetChineseStr,
    GetEngStr,
    full2half,
    TrimAllWhitespaces,
    CalcuateAge,
    TWPhoneFormatCheck,
    MobilephoneFormatCheck,
    ReplaceSpecialChar,
    GeneralAllowInput,
    ReplaceNumerInput,
    PaddingText,
    ConsoleLog,
    FileToBase64,
    ObjectToBase64,
    Base64ToImage,
    SetValue,
    GetLeftTimeText,
    ToHtmlEntities,
    HtmlspecialChars,
    TryParseInt,
    ParseFloat,
    Throttle,
    IsFileNameValid
};
